<template>
    <transition name="fade">
        <div class="row justify-content-center">
            <div class="col-lg-6">
                <div class="card card-body">

                    <template v-if="formProcess[0].loan_type=='FIB01' && formProcess[0].program=='cares3'">
                        <i class="fas fa-exclamation-circle fs-55 text-center info"></i>
                        <p class="text-center fs-30 bold my-3">Notice</p>
                        <p class="text-center fs-15">All pending Regular Business applications should be completed within 15 days from the date of the cut-off (January 31, 2022 @ 11:59pm) or else those will be automatically disabled by the system.</p>
                        <hr>
                    </template>

                    <i class="fas fa-bell fs-55 text-center warning"></i>
                    <p class="text-center fs-30 bold my-3">Notification</p>
                    <!-- <p class="text-center fs-17">Do you want to continue with your loan application?</p> -->
                    <!-- <p v-if="formProcess[0].program=='cares'" class="text-center fs-15">Click <b>"Yes"</b> if you want to continue with your <strong>HEROES</strong> loan application.</p>
                    <p v-else-if="formProcess[0].program=='erf'" class="text-center fs-15">Click <b>"Yes"</b> if you want to continue with your <strong>Odette ERF</strong> loan application.</p> -->

                    <p class="text-center fs-15">Click <b>"Yes"</b> if you want to continue with your <strong>{{refFilter(loan_cat, 'loan_type', formProcess[0].loan_type, 'loan_desc')}}{{erf}}</strong> loan application.</p>

                    <p class="text-center fs-15">Click <b>"No"</b> if you want to apply for another program. This will delete all the information you provided in your existing loan application.</p>



                    <div class="row">
                        <div class="col-12 text-center">
                            <button class="btn2 btn btn-primary mr-1" @click="onConfirm">Yes</button>
                            <button class="btn2 btn btn-outline-primary" @click="onCancel">No</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import loan_cat from "@json/loan_cat.json";
    import moment from 'moment';
    import {
        required
    } from 'vuelidate/lib/validators';


    export default {
        props: ['formProcess'],

        data() {
            return {
                loan_cat: loan_cat,
                erf: '',
            }
        },
        validations: {

        },
        created() {},
        methods: {
            refFilter(obj, key, val, equiv) {
                let data = obj.find(i => i[key] == val);
                return data ? data[equiv] : '';
            },
            onConfirm() {
                let x = this.formProcess[0].program;
                let y = this.formProcess[0].loan_type;
                if (x == 'cares3') {
                    if (y == 'FIB01') {
                        this.$router.push('/apply-loan/b2c');
                    }
                    if (y == 'FIB02') {
                        this.$router.push('/apply-loan/b2c');
                    }
                    if (y == 'FIB03') {
                        this.$router.push('/apply-loan/b2c');
                    }
                    if (y == 'FIB05') {
                        this.$router.push('/apply-loan/b2c');
                    }
                    if (y == 'FIB09') {
                        this.$router.push('/apply-loan/b2c');
                    }
                    if (y == 'FIB04') {
                        this.$router.push('/apply-loan/actoo');
                    }
                    if (y == 'FIB07') {
                        this.$router.push('/apply-loan/13th-month');
                    }
                }
                if (x == 'staples') {
                    this.$router.push('/apply-loan/staples');
                }
                if (x == 'cares') {
                    this.$router.push('/heroes-application');
                }
                if (x == 'rise-up') {
                    switch (y) {
                        case 'FIB10':
                            // this.$router.push('/apply-loan/rise-up');
                            this.$router.push('/apply-loan/sblaf-rise-up-mp');
                            break;
                        case 'FIB11':
                            // this.$router.push('/apply-loan/rise-up-ft');
                            this.$router.push('/apply-loan/sblaf-rise-up-ft');
                            break;
                        case 'FIB12':
                        case 'FIB13':
                            this.$router.push('/apply-loan/rise-up-turismo');
                            break;
                        case 'FIB14':
                            this.$router.push('/apply-loan/sblaf-rise-up-suki');
                            // this.$router.push('/apply-loan/rise-up-suki');
                            break;
                        case 'FIB15':
                            this.$router.push('/apply-loan/rise-up-tindahan');
                            break;
                        case 'FIB16':
                            this.$router.push('/apply-loan/rise-up-month13');
                            break;
                        default:
                    }
                }
                if (x == 'erf') {
                    this.$router.push('/apply-loan/erf');
                }
                if (x == 'startup') {
                    this.$router.push('/apply-loan/startup');
                }
                if (x == 'po-financing') {
                    this.$router.push('/apply-loan/po-financing');
                }
                if (x == 'franchising') {
                    this.$router.push('/apply-loan/franchising');
                }
                if (x == 'falah') {
                    switch (y) {
                        case 'FIB21':
                            this.$router.push('/apply-loan/sblaf-falah-mp');
                            break;
                        case 'FIB22':
                            this.$router.push('/apply-loan/sblaf-falah-ft');
                            break;
                        case 'FIB23':
                            this.$router.push('/apply-loan/sblaf-falah-suki');
                            break;
                        default:
                    }
                }
                if (x == 'wef') {
                    switch (y) {
                        case 'FIB28':
                            this.$router.push('/apply-loan/sblaf-women-enterprise-fund-mp');
                            break;
                        case 'FIB29':
                            this.$router.push('/apply-loan/sblaf-women-enterprise-fund-ft');
                            break;
                        case 'FIB30':
                            this.$router.push('/apply-loan/sblaf-women-enterprise-fund-suki');
                            break;
                        default:
                    }
                }
            },
            onCancel() {
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'No',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.value) {
                        this.deleteLoanApp();
                    }
                })
            },
            deleteLoanApp() {
                this.$parent.payloading = true;
                axios.post('/api/v2-del-loan-app', {

                        application_id: this.formProcess[0].application_id,

                    })
                    .then(res => {
                        this.$parent.payloading = false;
                        Fire.$emit('indexApplyLoan');
                    }).catch(err => {
                        this.$parent.payloading = false;
                    })
            },
        },
        computed: {},

        mounted() {

            if (this.formProcess[0].loan_type == 'FIB17') {
                axios.get('/api/sblaf-erf-program', {
                    params: {
                        application_id: this.formProcess[0].application_id
                    },
                }).then(res => {
                    this.erf = ' - ' + res.data;
                })
            }
        }
    }
</script>

<style scoped>

</style>